/**
 * @generated SignedSource<<cc9e8d64ad349f972d4f86214d58654c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueTypePickerIssueType$data = {
  readonly color: IssueTypeColor;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly isEnabled: boolean;
  readonly name: string;
  readonly pinnedFields: ReadonlyArray<{
    readonly __typename: "IssueFieldDate";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "IssueFieldNumber";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "IssueFieldSingleSelect";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    readonly __typename: "IssueFieldText";
    readonly dataType: IssueFieldDataType;
    readonly id: string;
    readonly name: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }> | null | undefined;
  readonly " $fragmentType": "IssueTypePickerIssueType";
};
export type IssueTypePickerIssueType$key = {
  readonly " $data"?: IssueTypePickerIssueType$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTypePickerIssueType"
};

(node as any).hash = "44a917d251649f0c82e84234a314f1ac";

export default node;
